import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { TextView } from "@components";
import { ASSETS } from "../../../../utils/config";

const HeaderContainer = styled.div``;

const Logo = styled.img`
  height: 40px;
  width: 42px;
`;

const WheelInfo = styled.div`
  padding: 10px;
  padding-top: 0px;
  width: 90%;
`;

const WheelTitle = styled(TextView)`
  margin-bottom: 5px;
`;

const WheelDescription = styled(TextView)`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 14px;
`;

const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
`;

const InfoIcon = styled.img`
  height: 3vh;
  width: 5vw;
  margin-right: 4vw;
`;

const MenuBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  background-color: #f6f7f9;
`;

const Description = styled(TextView)`
  text-align: center;
  margin: 4vw;
`;

const Container = styled.div`
  border-image-source: linear-gradient(
    90deg,
    #f7fed5 0.51%,
    #ccfeff 35.32%,
    #fdcffe 60.23%,
    #f5eede 96.53%
  );

  background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.7),
      rgba(255, 255, 255, 0.7)
    ),
    conic-gradient(
      from 180deg at 50% 50%,
      #f5eede -41.73deg,
      #f7fed5 53.81deg,
      #ccfeff 133.87deg,
      #fdcffe 244.39deg,
      #f5eede 318.27deg,
      #f7fed5 413.81deg
    );

  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 94vw;
  margin: 2vw;
  overflow: hidden;
  border-radius: 10px;
  position: absolute;
  z-index: 100;
`;

function Header({ wheelName, description, subtitle, onHamburgerIconClick }) {
  const [showDescription, setShowDescription] = useState(false);
  const containerRef = useRef();

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setShowDescription(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <HeaderContainer>
        <TopRow>
          <Logo alt="logo" src={ASSETS.MobileLogo} />
          <MenuBox>
            <img
              onClick={onHamburgerIconClick}
              src={ASSETS.Hamburger}
              alt="menu"
              style={{ cursor: "pointer" }}
            />
          </MenuBox>
        </TopRow>

        <div ref={containerRef} onClick={(e) => e.stopPropagation()}>
          <TitleRow>
            <WheelInfo>
              <WheelTitle variant="title">{wheelName}</WheelTitle>
              <WheelDescription>{subtitle}</WheelDescription>
            </WheelInfo>

            <InfoIcon
              alt="desc"
              src={showDescription ? ASSETS.MobileDesc : ASSETS.MobileDesc2}
              onClick={() => setShowDescription(!showDescription)}
            />
          </TitleRow>
          {showDescription ? (
            <Container>
              <Description>{description}</Description>
            </Container>
          ) : null}
        </div>
      </HeaderContainer>
    </>
  );
}

export default Header;
